import React from 'react'
import { BAR_H, LINK_HANDLE_GAP, LINK_HANDLE_R, RESIZE_HANDLE_W, ROW_H } from '../../lib/constants'

export interface TaskBarProps {
  x: number
  width: number
  rowTop: number
  label: string
  percent: number
  critical: boolean
  selected: boolean
  shiftUp: boolean
  activityId: string
  /** Task 18: right-edge resize handle + link handle, shown while hovered or selected (and only
   * when the caller can edit — `GanttTimeline` computes this). */
  showHandles?: boolean
  onPointerEnter?: (e: React.PointerEvent) => void
  onPointerLeave?: () => void
  onClick?: (e: React.MouseEvent) => void
}

/** Leaf, non-milestone activity. Spec B §8.4. */
const TaskBar: React.FC<TaskBarProps> = ({ x, width, rowTop, label, percent, critical, selected, shiftUp, activityId, showHandles, onPointerEnter, onPointerLeave, onClick }) => {
  const y = rowTop + (ROW_H - BAR_H) / 2 - (shiftUp ? 4 : 0)
  const w = Math.max(2, width)
  const handleRight = LINK_HANDLE_GAP + LINK_HANDLE_R
  const labelX = x + w + (showHandles ? handleRight + 6 : 6)
  return (
    <g data-bar data-activity-id={activityId} onPointerEnter={onPointerEnter} onPointerLeave={onPointerLeave} onClick={onClick} className="cursor-pointer">
      <rect x={x} y={y} width={w} height={BAR_H} rx={3} className={critical ? 'fill-destructive' : 'fill-primary'} />
      {percent > 0 && <rect x={x} y={y} width={(w * Math.min(100, percent)) / 100} height={BAR_H} rx={3} className="fill-black/25" />}
      {selected && <rect x={x - 1} y={y - 1} width={w + 2} height={BAR_H + 2} rx={4} className="fill-none stroke-primary stroke-2" />}
      {showHandles && (
        <>
          <rect
            data-resize-handle
            data-activity-id={activityId}
            x={x + w - RESIZE_HANDLE_W / 2}
            y={y}
            width={RESIZE_HANDLE_W}
            height={BAR_H}
            rx={1}
            className="fill-primary stroke-background cursor-ew-resize"
          />
          <circle
            data-link-handle
            data-activity-id={activityId}
            cx={x + w + LINK_HANDLE_GAP}
            cy={y + BAR_H / 2}
            r={LINK_HANDLE_R}
            className="fill-background stroke-primary stroke-2 cursor-crosshair"
          />
        </>
      )}
      <text x={labelX} y={y + BAR_H / 2} dominantBaseline="middle" className="text-xs fill-foreground pointer-events-none select-none">{label}</text>
    </g>
  )
}

export default TaskBar
